import { FacebookIcon, InstagramIcon, LinkedinIcon } from 'lucide-react';

import { Copyright, Icon, Link, Links, SocialMedia, Underlay, Wrapper } from './footer.styles';

import ContactUsLink from './contact_us_link';
import PrivacyPolicyDialog from './privacy_policy_dialog';
import PrivacyPolicyLink from './privacy_policy_link';
import ServiceContractDialog from './service_contract_dialog';
import ServiceContractLink from './service_contract_link';

const items = [
  {
    label: 'Facebook',
    icon: FacebookIcon,
    href: 'https://www.facebook.com/RewardoLoyaltyApp',
  },
  {
    label: 'LinkedIn',
    icon: LinkedinIcon,
    href: 'https://www.linkedin.com/company/rewardo-loyalty-app/',
  },
  {
    label: 'Instagram',
    icon: InstagramIcon,
    href: 'https://www.instagram.com/rewardo_loyalty/',
  },
];

const COPYRIGHT_START_YEAR = 2020;

const currentYear = new Date().getFullYear();
const copyrightYear =
  currentYear === COPYRIGHT_START_YEAR
    ? COPYRIGHT_START_YEAR
    : `${COPYRIGHT_START_YEAR}–${currentYear}`;

export default function Footer() {
  return (
    <>
      <Wrapper>
        <Links>
          <ServiceContractLink />
          <PrivacyPolicyLink />
          <ContactUsLink />
        </Links>
        <SocialMedia>
          {items.map((item) => {
            const IconComponent = item.icon;

            return (
              <Link
                key={item.label}
                href={item.href}
                title={item.label}
                rel="noopener noreferrer"
                target="_blank"
              >
                <Underlay />
                <Icon>
                  <IconComponent />
                </Icon>
              </Link>
            );
          })}
        </SocialMedia>
        <Copyright>{`© Rewardo sp. z o.o. ${copyrightYear}`}</Copyright>
      </Wrapper>
      <ServiceContractDialog />
      <PrivacyPolicyDialog />
    </>
  );
}
